import { render, staticRenderFns } from "./df-tabbed-panel.vue?vue&type=template&id=0ab56d14"
import script from "./df-tabbed-panel.ts?vue&type=script&lang=ts&external"
export * from "./df-tabbed-panel.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports